import create from 'zustand';

const useSearchAndFilterStore = create((set, get) => ({
    instances: {},

    createInstance(instanceName) {
        const { instances } = get();
        if (instances[instanceName]) {
            console.warn(`Instance ${instanceName} already exists.`);
            return;
        }
        instances[instanceName] = {
            initial: null,
            filtered: null,
            filter: null,
            selected: [],
        };
        set(() => ({ instances }));
    },

    getInstance: instanceName => {
        const { instances } = get();
        if (!instances[instanceName]) {
            console.warn(`Instance ${instanceName} does not exist.`);
            return null;
        }
        return instances[instanceName];
    },

    setInitial: (instanceName, initial) => {
        const { instances } = get();
        if (!instances[instanceName]) {
            console.warn(`Instance ${instanceName} does not exist.`);
            return;
        }
        instances[instanceName].initial = initial;
        set(() => ({ instances }));
    },

    setFiltered: (instanceName, filtered) => {
        const { instances } = get();
        if (!instances[instanceName]) {
            console.warn(`Instance ${instanceName} does not exist.`);
            return;
        }
        instances[instanceName].filtered = filtered;
        set(() => ({ instances }));
    },

    setFilter: (instanceName, filter) => {
        const { instances } = get();
        if (!instances[instanceName]) {
            console.warn(`Instance ${instanceName} does not exist.`);
            return;
        }
        instances[instanceName].filter = filter;
        set(() => ({ instances }));
    },

    setSelected: (instanceName, selected) => {
        const { instances } = get();
        if (!instances[instanceName]) {
            console.warn(`Instance ${instanceName} does not exist.`);
            return;
        }
        instances[instanceName].selected = selected || [];
        set(() => ({ instances }));
    },

    reset: instanceName => {
        const { instances } = get();
        if (!instances[instanceName]) {
            console.warn(`Instance ${instanceName} does not exist.`);
            return;
        }
        instances[instanceName] = {
            initial: null,
            filtered: null,
            filter: null,
            selected: [],
        };
        set(() => ({ instances }));
    },
}));

export { useSearchAndFilterStore };
